import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirebaseApp } from '@bridebook/web/lib/configure-deps';

/**
 * Hook to check if user is authenticated via Firebase Auth
 * Works in both Basic and Full apps as it doesn't depend on Redux
 */
export const useIsAuthenticated = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    try {
      const firebaseApp = getFirebaseApp();
      const auth = getAuth(firebaseApp);

      const unsubscribe = onAuthStateChanged(auth, (user) => {
        setIsAuthenticated(!!user);
        setIsLoading(false);
      });

      return () => unsubscribe();
    } catch (error) {
      // If Firebase is not initialized, user is not authenticated
      setIsAuthenticated(false);
      setIsLoading(false);
    }
  }, []);

  return { isAuthenticated, isLoading };
};
